export default __webpack_public_path__ + "static/media/search.5a208c66.svg";